import { render, staticRenderFns } from "./submitForm.vue?vue&type=template&id=12eb1344&scoped=true"
import script from "./submitForm.vue?vue&type=script&lang=js"
export * from "./submitForm.vue?vue&type=script&lang=js"
import style0 from "./submitForm.vue?vue&type=style&index=0&id=12eb1344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb1344",
  null
  
)

export default component.exports